(function ($) {
    function animateNumber(el, duration = 2000) {
        let start = 0;
        let end = parseInt(el.getAttribute("data-target"), 10);
        let range = end - start;
        let startTime = null;

        function step(timestamp) {
            if (!startTime) startTime = timestamp;
            let progress = Math.min((timestamp - startTime) / duration, 1);
            el.innerText = Math.floor(progress * range);

            if (progress < 1) {
                requestAnimationFrame(step);
            }
        }

        requestAnimationFrame(step);
    }

    function startAnimationWhenVisible(entries, observer) {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                let el = entry.target;
                animateNumber(el);
                observer.unobserve(el);
            }
        });
    }

    $(document).ready(function () {
        let observer = new IntersectionObserver(startAnimationWhenVisible, {
            root: null,
            threshold: 0.5 // Запуск, когда элемент виден на 50%
        });

        $('.statistics-number').each(function () {
            observer.observe(this); // ✅ Начинаем отслеживать элементы
        });
    });
})(jQuery);
